import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSimCard2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sim-card-2"><path d="M19.25 2.75H8.75L4.75 6.75V21.25H19.25V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.25 2.75V7.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 2.75V7.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSimCard2;
